import * as React from "react";

// style, design
import { ToolTipCell } from "../../Displays";

import SimpleTextFilter from "src/components/Lists/Base/CompleteList/Filters/TextFilter";
import { StatusLabel } from "src/components/Lists/Base/CompleteList/styles";
export default (hasBillectaViewPermission) => {
  const cols = [
    {
      Header: "Logotyp",
      accessor: "company.image.get",
      Cell: ({ value }) => (
        <div
          style={{
            height: "60px",
            width: "60px",
            borderRadius: "5px",
            backgroundImage: `url(${value})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
          }}
        ></div>
      ),
      Filter: SimpleTextFilter,
      filter: "text",
    },
    {
      Header: "Namn",
      accessor: "company.name",
      Cell: ({ value }) => <ToolTipCell text={value} />,
      Filter: SimpleTextFilter,
      filter: "text",
    },
    {
      Header: "Orgnr",
      accessor: "company.orgnr",
      Cell: ({ value }) => <ToolTipCell text={value} />,
      Filter: SimpleTextFilter,
      filter: "text",
    },
  ];

  if (hasBillectaViewPermission) {
    cols.splice(3, 0, {
      Header: "Fakturering aktiverad",
      accessor: "company.billecta_id",
      Cell: ({ value }) => (
        <StatusLabel state={value ? 0 : 3}>
          {value ? "Aktiv" : "Inaktiv"}
        </StatusLabel>
      ),
      Filter: SimpleTextFilter,
      filter: "text",
    });
  }
  return cols;
};
